export enum CouponType {
    Luncheon = 'LUNCHEON',
    Fidelity = 'FIDELITY',
    Voucher = 'VOUCHER',
    Sponsorship = 'SPONSORSHIP',
    Refund = 'REFUND',
    Participation = 'PARTICIPATION',
}

export enum CouponValueType {
    Percent = 'PERCENT',
    Value = 'VALUE',
    Product = 'PRODUCT',
}

export default {
    CouponType,
    CouponValueType,
}
